import {Component, OnInit, Input, OnChanges} from '@angular/core';

import {IChartOptions, IChartData} from './chart-options';
import {CallCauseUtil} from '../../../shared/utils/call-cause';
import {TranslateService} from '@ngx-translate/core';
import {CallLogEntryModel} from '../../../models/call-log-entry.model';

@Component({
  selector: 'gt-statistics-chart',
  templateUrl: './statistics-chart.component.html',
  styleUrls: ['./statistics-chart.component.scss']
})
export class StatisticsChartComponent implements OnInit, OnChanges {
  public numberOfCalls: number;
  public averageCallDuration: number;
  public answeredCallNo: number;
  public unAnsweredCallNo: number;
  public aHangupCallNo: number;

  public answeredCallPercentage: number;
  public unAnsweredCallPercentage: number;
  public aHangupCallPercentage: number;

  public answeredCallColor = '#4CAF50';
  public unAnsweredCallColor = '#cd3839';
  public aHangupCallColor = '#d36b39';

  public colorScheme = {domain: [this.answeredCallColor, this.unAnsweredCallColor, this.aHangupCallColor]};

  public statisticsData = [];
  public chartOptions: IChartOptions;

  @Input() logEntries: CallLogEntryModel[];

  constructor(private translateService: TranslateService) {
    translateService.onLangChange.subscribe(() => {
      this.calculateStatistics();
    });
  }

  ngOnInit() {
    this.calculateStatistics();
  }

  ngOnChanges() {
    this.calculateStatistics();
  }

  private resetCounters() {
    this.numberOfCalls = 0;
    this.averageCallDuration = 0;

    this.answeredCallNo = 0;
    this.unAnsweredCallNo = 0;
    this.aHangupCallNo = 0;

    this.answeredCallPercentage = 0;
    this.unAnsweredCallPercentage = 0;
    this.aHangupCallPercentage = 0;
    this.statisticsData = [];
  }

  private calculateStatistics() {
    this.resetCounters();
    if (!this.logEntries) {
      return;
    }
    console.log('calculateStatistics ' + this.logEntries.length);

    let totalDuration = 0;
    this.logEntries.forEach((logEntry: CallLogEntryModel) => {
      totalDuration += logEntry.duration;

      if (CallCauseUtil.isCallAnswered(logEntry.cause)) {
        this.answeredCallNo++;
      } else if (CallCauseUtil.isAAbandon(logEntry.cause)) {
        this.aHangupCallNo++;
      } else if (CallCauseUtil.isCallMissed(logEntry.cause)) {
        this.unAnsweredCallNo++;
      } else {
        console.log('Unknown callresult: ' + JSON.stringify(logEntry));
      }
    });

    this.numberOfCalls = this.logEntries.length;

    if (this.numberOfCalls) {
      this.statisticsData = [
        {
          name: this.translateService.instant('statistics_chart.answered'),
          value: this.answeredCallNo
        },
        {
          name: this.translateService.instant('statistics_chart.unanswered'),
          value: this.unAnsweredCallNo
        },
        {
          name: this.translateService.instant('statistics_chart.hung_up'),
          value: this.aHangupCallNo
        }
      ];

      this.averageCallDuration = Math.round((totalDuration * 10) / this.numberOfCalls) / 10;
      this.answeredCallPercentage = Math.round((this.answeredCallNo / this.numberOfCalls) * 100);
      this.unAnsweredCallPercentage = Math.round((this.unAnsweredCallNo / this.numberOfCalls) * 100);
      this.aHangupCallPercentage = Math.round((this.aHangupCallNo / this.numberOfCalls) * 100);
    } else {
      this.statisticsData = [];
    }
  }
}
